import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import goodJobSvg from '../../images/goodJob.svg';
import CircularProgress from '@material-ui/core/CircularProgress';
import Transition from './Transition';

const styles = {
	goodJobIcon: {
		display : 'inline-block',
		width : 50,
		height : 50,
		backgroundImage: `url('${goodJobSvg}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
	},
	title : {
		fontSize : 30,
		display: 'inline-block',
		verticalAlign: 'middle',
		paddingLeft: 5,
		paddingTop: 5,
	}
};

export default class UpdatingDeliveryDialog extends Component {
	constructor (props) {
		super(props);
		this.handleRequestClose = this.handleRequestClose.bind(this);
	}

	handleRequestClose() {
		this.props.history.push(`/logistics/deliveries`);
		this.props.onClose();
	}
	render() {
		const { status } = this.props;
		return (
			<div>
				<Dialog
					open={this.props.open}
					TransitionComponent={Transition}
					onClose={this.handleRequestClose}
				>
					<DialogTitle>
						<div>
							{status === 'updating' &&
								<div>
									<CircularProgress />
									<span style={styles.title}>Updating Delivery...</span>
								</div>
							}
							{status !== 'updating' &&
								<div>
									<div style={styles.goodJobIcon}/>
									<span style={styles.title}>Success!</span>
								</div>
							}
						</div>
					</DialogTitle>
					<DialogContent>

						{status !== 'done' &&
						<DialogContentText>
							<span>Updating delivery and processing the delivery.</span>
						</DialogContentText>
						}

						{status === 'done' &&
						<DialogContentText>
							Delivery updated. No change request sent.
						</DialogContentText>
						}

						{status === 'doneWithAlert' &&
						<DialogContentText>
							Delivery updated and change requests have been sent.
						</DialogContentText>
						}

					</DialogContent>
					<DialogActions>
						<Button
							disabled={status !== 'done' && status !== 'doneWithAlert' }
							onClick={this.handleRequestClose}
							color="primary"
						>
							Continue
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}

UpdatingDeliveryDialog.propTypes = {
	status : PropTypes.string,
	open : PropTypes.bool,
	onClose : PropTypes.func,
	history : PropTypes.object.isRequired,
};